import { Typography } from '@mui/material'
import { TooltipCC } from "components/common"

export const RolesPariticpant = [
    {
        name: 'Người sở hữu',
        value: 'owner'
    },
    {
        name: 'Chủ trì',
        value: 'host'
    },
    {
        name: 'Đồng chủ trì',
        value: 'coHost'
    },
    {
        name: 'Người tham dự',
        value: 'participant'
    }
]

export const RenderEmailOrNameUser = ({name}) => {
    return (<TooltipCC title={name.length > 60 ? name : ''}>
            {name.length > 60 ? name.slice(0, 24) + '...' + name.slice(name.length - 24, name.length) : name}
        </TooltipCC>)
}

export const RenderEmailOrNameUserDisplay = ({name, email}) => {
    if(!name) return <span>123</span>
    return (
        <TooltipCC title={name ? (name?.length <= 20 ? email : `${email} - ${name}`) : email}>
            {
            name 
            ? 
            (name.length > 20 ? name.slice(0, 17) + '...' : name) 
            : 
            (email.length > 20 ? email.slice(0, 17) + '...' : email)
            }
        </TooltipCC>
    )
}

export const RenderEmailOrNameUserDisplayDetail = ({name, email}) => {
    return (
        <TooltipCC title={name.length <= 40 ? email : `${email} - ${name}`}>
            <Typography fontWeight={550}>{
                name 
                ? 
                (name.length > 40 ? name.slice(0, 37) + '...' : name) 
                : 
                (email.length > 40 ? email.slice(0, 37) + '...' : email)
            }
            </Typography>
        </TooltipCC>
    )
}

/**
 * Hiển thị trường thông tin của người dùng
 * @param {*} value 
 */
export const RenderInfoUser = ({value}) => {
    if(!value) return '---'

    let _value = value;

    if(value.length > 60) _value = value.slice(0, 24) + '...' + value.slice(value.length - 24, value.length)
    // if(value.length > 40) _value = value.slice(0, 37) + '...'
    // if(value.length > 20) _value = _value.slice(0, 17) + '...'

    return <TooltipCC title={value}>{_value}</TooltipCC>
}

export const ACTION_TYPE = {
    DELETE: 'DELETE',
    RESTORE: 'RESTORE',
    DELETE_FOREVER: 'DELETE_FOREVER'
}

export const SELECTED_TYPE = {
    ALL: 'ALL',
    MULTIPLE: 'MULTIPLE',
    ONE: 'ONE'
}

export const ROLE = {
    OWNER: "owner",
    HOST: "host",
    CO_HOST: "coHost",
    PARTICIPANT: "participant"
}